import {Component, Injectable, OnInit} from '@angular/core';
import {Subject} from "rxjs";
import {LoaderService} from "../../services/loader.service";

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
@Injectable({
  providedIn: 'root',  // This ensures the service is available application-wide
})
export class LoaderComponent implements OnInit {

  isLoading: Subject<boolean> = this.loaderService.isLoading;

  constructor(public loaderService: LoaderService) {
  }

  ngOnInit() {

  }

}
